import { useOnHasUnreadMessagesChangedSubscription } from "@/modules/chats/services/useOnHasUnreadMessagesChangedSubscription"

export const ChatBadgeItem = () => {
  const showUnreadNotification = useOnHasUnreadMessagesChangedSubscription()

  return showUnreadNotification ? (
    <div
      className="bg-critical absolute top-5 right-4 h-1.5 w-1.5 rounded-full"
      data-testid="new-chat-notification-bubble"
    />
  ) : null
}
